import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { oauth } from "../utils";
import { toast } from "react-toastify";

export interface RecentProject {
  job_id: string;
  job_number: string;
  job_name: string;
  client_name: string;
  date_created: string;
  form_number: string;
  order_type: string;
}

type LoadingState = "idle" | "pending";

export interface RecentProjectsState {
  projects: RecentProject[];
  loading: LoadingState;
  error: string | null;
}

export type RecentProjectsRootState = {
  recentProjects: RecentProjectsState;
};
type RootState = RecentProjectsRootState;

const initialState: RecentProjectsState = {
  projects: [],
  loading: "idle",
  error: null,
};

export const FETCH_RECENT_PROJECTS = "recentProjects/fetchRecentProjects";
export const fetchRecentProjects = createAsyncThunk(FETCH_RECENT_PROJECTS, async () => {
  const { json } = await oauth("GET", "global-search/recent-projects-toc", {});
  return (json?.results ?? []) as RecentProject[];
});

const slice = createSlice({
  name: "recentProjects",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecentProjects.pending, (state) => {
        state.loading = "pending";
        state.error = null;
      })
      .addCase(fetchRecentProjects.fulfilled, (state, action) => {
        state.loading = "idle";
        state.projects = action.payload;
      })
      .addCase(fetchRecentProjects.rejected, (state, action) => {
        state.loading = "idle";
        state.error = action.error?.message || "Failed to load recent projects";
        toast.error(state.error);
      });
  },
});

// Selectors
export const selectRecentProjects = (state: RootState) => state.recentProjects.projects;

export const selectRecentProjectsLoading = (state: RootState) =>
  state.recentProjects.loading === "pending";

export const selectRecentProjectsError = (state: RootState) => state.recentProjects.error;

export default slice;
